import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
    selector: 'app-browse-folder',
    templateUrl: './browse-folder.component.html',
    styleUrls: ['./browse-folder.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrowseFolderComponent implements OnInit {
    constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {}

    ngOnInit(): void {}
}
